import Page from "components/Page";
import { getListManutencaoEvolucaoSites } from "../data";

function ManutencaoEvolucao() {
  const data = getListManutencaoEvolucaoSites().filter((item) => item.productId === "#MES01");
  return <Page pageData={data} />;
}

export default ManutencaoEvolucao;
